import { withSentryReactRouterV6Routing } from '@vs/sentry-react-router-integration';
import { PortalBackdrop } from '@vs/ui/portal/backdrop';
import { Suspense, memo, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Navigate,
  Route,
  Routes,
  matchPath,
  useLocation,
} from 'react-router-dom';

import { RouteConfig, context } from './spa-path-config-provider';
import { flattenAppPathsAndView } from './utils';

const SentryRoutes = withSentryReactRouterV6Routing(Routes);

export const SpaRoutesByPathsConfig = memo(() => {
  const { t } = useTranslation();
  const location = useLocation();
  const { configs: pathsConfig, appNameI18nKey } = useContext(context);
  const pathsAndView = flattenAppPathsAndView(pathsConfig);
  const defaultFallbackPath = pathsAndView.find(
    p => p.type === 'path' && p.isFallbackPath
  ) as RouteConfig;

  useEffect(() => {
    const currentPathConfig = pathsAndView.find(p =>
      matchPath(p.path || '', location.pathname)
    );
    if (currentPathConfig && currentPathConfig.menuMeta) {
      document.title = `${t(currentPathConfig.menuMeta.labelI18n)} - Viewsonic${appNameI18nKey ? ` | ${t(appNameI18nKey)}` : ''}`;
    }
  }, [location, pathsAndView, appNameI18nKey, t]);

  return (
    <Suspense fallback={<PortalBackdrop open type="module_init" />}>
      <SentryRoutes>
        {pathsAndView
          .map(p => <Route key={p.path} path={p.path} element={<p.View />} />)
          .flat()}
        {defaultFallbackPath !== undefined && (
          <Route
            path="*"
            element={
              <Navigate
                to={{
                  pathname: defaultFallbackPath.path,
                  search: location.search,
                }}
              />
            }
          />
        )}
      </SentryRoutes>
    </Suspense>
  );
});
